// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-active {\n  color: #00A551;\n  cursor: pointer;\n}\n.stateType .el-input__inner {\n  border: 0;\n  padding: 0;\n  height: 28px;\n  line-height: 28px;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
